import React from 'react';
import Alert, { AlertColor } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export interface AlertControlProps {
  title: string;
  severity: AlertColor | undefined;
  message: string;
  onClose?: (event?: React.SyntheticEvent, reason?: string) => void;
  children?: React.ReactNode;
}

export const AlertControl = ({
  title,
  severity,
  message,
  onClose,
  children,
}: AlertControlProps) => {
  return (
    <Alert onClose={onClose} severity={severity} variant="standard">
      <AlertTitle>{title}</AlertTitle>
      {message}
      <div>{children}</div>
    </Alert>
  );
};
